import { render, staticRenderFns } from "./ProductRequiredNotesConfirmationModal.vue?vue&type=template&id=2af87216&"
import script from "./ProductRequiredNotesConfirmationModal.vue?vue&type=script&lang=js&"
export * from "./ProductRequiredNotesConfirmationModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports